export const CreditCardIcon = () => {
    return (
        <svg width="20" height="16" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="20" height="16" rx="2" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></rect>
            <path d="M5 5.99997L17 5.99997" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M5 10L11 10" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
}